import { useState, useEffect } from 'react';
import { message as antdMessage, Button, Checkbox, Form, Select, Input, Modal } from 'antd';
import PartnerForm from '../PartnerForm';

import styles from './index.module.scss';

export default function Comp({ visible, onClose }: any) {
    const [modalVisible, setModalVisible] = useState(visible);

    const handleCancel = () => {
        onClose && onClose();
    };

    useEffect(() => {
        setModalVisible(visible);
    }, [visible]);

    return (
        <Modal visible={modalVisible} onCancel={handleCancel} className={styles.partnerModal} footer={null}>
            <PartnerForm onSuccess={handleCancel} />
        </Modal>
    );
}
